import { da } from "date-fns/locale";
import { isbot } from 'isbot';
import {
  GetAppLoadCount,
  getOrCreateWorkySubSessionIdToSessionStorage,
  IncrementAppLoadCount,
  saveWorkySessionIdToLocalStorage,
} from "../../../common/CommonUtilsMethods";
import { FetchIPAddressDetails, TrackSalesEvent, UpdateSalesTrackerExitAPICall } from "../sales-related-api/SalesTrackerAPICalls";
import { IPAddressDetailsDTO, SalesTrackerExitReqDTO } from "../sales-related-data/SalesTrackerHotIntakeInterfaces";
const isBotOrCrawler = (): boolean => {
  try{
    if (typeof navigator === 'undefined') return true;
    return isbot(navigator.userAgent);
  }catch(error){
    console.error("Error checking if bot or crawler:", error);
    return false;
  }
  
};
const MakeRemoteTrackingEventCall = async ({ eventName }: { eventName: string }) => {
  // Skip tracking for bots and crawlers
  if (isBotOrCrawler()) {
    console.log("Skipping tracking for bot/crawler:", navigator?.userAgent);
    return;
  }

  // check if the worky_session_id is present,
  IncrementAppLoadCount();
  // Get current count from sessionStorage
  const currentCount = GetAppLoadCount();
  if (currentCount >= 20) {
    return;
  }
  // make call to IP EP
  const ipAddressDetails: IPAddressDetailsDTO | null = null;

  // TEMP: ipinfo API call disabled for splash/landing page tracking
  // try {
  //   ipAddressDetails = await FetchIPAddressDetails();
  // } catch (error) {
  //   console.log("Failed to fetch IP address details, continuing without it" + " ", error);
  // }

  // make call to sales tracker
  if (ipAddressDetails) {
    await TrackSalesEvent({ eventName: eventName, ipAddressDetails: ipAddressDetails });
  } else {
    await TrackSalesEvent({ eventName: eventName });
  }
};

const PushExitTimingEventCall = async () => {
  const subSussionId = getOrCreateWorkySubSessionIdToSessionStorage();
  const workySessionId = saveWorkySessionIdToLocalStorage();

  const currentCount = GetAppLoadCount();
  if (currentCount >= 20) {
    return;
  }

  await UpdateSalesTrackerExitAPICall({
    workySessionId: workySessionId,
    workySubSessionId: subSussionId,
  });
};

const ListenForPageCloseAndExecute = (callback?: () => Promise<void>) => {
  console.log("invoking ListenForPageCloseAndExecute prior to listener");
  // Add an event listener that uses navigator.sendBeacon for reliable data sending during page unload

  try {
    window.addEventListener("beforeunload", () => {
      try {
        console.log("invoking beforeunload prior to listener");
        // Execute the callback (which should be PushExitTimingEventCall)
        // We can't await the promise here, but the beacon API will handle sending data reliably
        // callback();

        // For browsers that don't support/restrict fetch in beforeunload,
        // we can add a fallback with sendBeacon for critical data
        const subSessionId = getOrCreateWorkySubSessionIdToSessionStorage();
        const workySessionId = saveWorkySessionIdToLocalStorage();
        const salesTrackerExitReqDTO: SalesTrackerExitReqDTO = {
          workySessionId: workySessionId,
          workySubSessionId: subSessionId,
        };

        // Create a minimal payload for the beacon
        const data = JSON.stringify(salesTrackerExitReqDTO);

        // Try to use sendBeacon as backup approach
        const endpoint = `${process.env.REACT_APP_BACK_END_SERVER_BASE_PATH_LOCAL}telemetry/client-tracker/sales-tracker/exit-timing`;

        const blob = new Blob([data], {
          type: "application/json",
        });

        // navigator.sendBeacon(endpoint, blob);
        // navigator.sendBeacon(endpoint, data);
        PushExitTimingEventCall();
        console.log("Exit event tracking initiated");
      } catch (error) {
        console.error("Failed to track exit event:", error);
      }
    });
  } catch (e) {
    console.log("ListenForPageCloseAndExecute ", e);
  }
};

export { MakeRemoteTrackingEventCall, ListenForPageCloseAndExecute, isBotOrCrawler };
